import { useState, useEffect } from 'react';

const TIMEOUT_TIME = 150;

function getWidthLessThanBreakpoint(desktopBreakpoints: number[]) {
    return desktopBreakpoints.map((dtBp) => window.innerWidth < dtBp);
}

const isEqualArray = (arr1: boolean[], arr2: boolean[]): boolean => {
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
};

/**
 *
 * @param desktopBreakpoints Default value is [1140] and default return value is [false]
 */
function useIsWidthLessThanBreakpoint(desktopBreakpoints = [1140]) {
    const [isMobile, setIsMobile] = useState<boolean[]>(
        desktopBreakpoints.map(() => false)
    );

    useEffect(() => {
        setIsMobile(getWidthLessThanBreakpoint(desktopBreakpoints));

        // add Debouncing to optimise resize call
        let timeoutId: NodeJS.Timeout;
        const handleResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(
                () =>
                    setIsMobile((currentIsMobile) => {
                        const newIsMobile = getWidthLessThanBreakpoint(
                            desktopBreakpoints
                        );
                        if (isEqualArray(currentIsMobile, newIsMobile)) {
                            return currentIsMobile;
                        }
                        return newIsMobile;
                    }),
                TIMEOUT_TIME
            );
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [...desktopBreakpoints]);

    return isMobile;
}

export default useIsWidthLessThanBreakpoint;
